'use client';

import { useFetchGwpName } from '@/hooks/useFetchGwpName';
import { getLanguageFromLocale } from '@/lib/i18n/config';

export type GiftLineNameProps = Readonly<{
  productId?: string;
  channelSlug?: string | null;
  locale: string;
  fallbackName: string;
}>;

/**
 * Renders a translated gift product name via the `com-gwp-name` Saleor attribute.
 * Falls back to `fallbackName` while loading or if the translation is unavailable.
 */
export const GiftLineName = ({
  productId,
  channelSlug,
  locale,
  fallbackName,
}: GiftLineNameProps) => {
  const name =
    useFetchGwpName({
      productId: productId ?? null,
      channel: channelSlug ?? null,
      languageCode: getLanguageFromLocale(locale).toUpperCase(),
    }) ?? fallbackName;

  return <>{name}</>;
};
